import { Box, Paper, Typography } from '@mui/material';
import { ItemWithId } from 'services/constants/types';
import { PaginationBlock } from 'ui/PaginationBlock';
import { PAGE_SIZE } from 'services/constants/env';
import { TEasTableWithoutFilterProps } from './types';
import { EasTable } from '../EasTable';

export const EasTableWithoutFilter = <T extends ItemWithId>({
	tableStructure,
	items,
	itemsIsLoading,
	handleAction,
	handleLink,
	skeletonRows,
	highlightedRow,
	children,
	showButtons,
	checkedIds = [],
	setCheckedIds = () => {},
	CustomComponent,
	pagination = true,
}: TEasTableWithoutFilterProps<T>) => {
	return (
		<Box>
			<Paper
				sx={{
					margin: '0px 10px 0 10px',
					maxWidth: 'calc(100vw - 20px)',
					overflowX: 'auto',
				}}
			>
				<Box sx={{ width: 'auto', minWidth: '1000px' }}>
					<Box sx={{ borderRadius: '12px' }}>
						{children && (
							<Box
								sx={{
									backgroundColor: 'primary.light',
									p: 0.5,
								}}
							>
								{children}
							</Box>
						)}
						{!!items && (
							<EasTable<T>
								tableStructure={tableStructure}
								items={items.items}
								itemsIsLoading={itemsIsLoading}
								handleAction={handleAction}
								handleLink={handleLink}
								skeletonRows={skeletonRows}
								highlightedRow={highlightedRow}
								showButtons={showButtons}
								checkedIds={checkedIds}
								setCheckedIds={setCheckedIds}
								CustomComponent={CustomComponent}
							/>
						)}
					</Box>
				</Box>
			</Paper>
			{pagination && (
				<Box
					sx={{
						padding: '0 20px 20px 20px',
						display: 'flex',
						justifyContent: 'space-between',
					}}
				>
					<PaginationBlock total={items?.totalCount ?? 0} isLoading={itemsIsLoading} />
					{!!items?.totalCount && items?.totalCount > PAGE_SIZE && (
						<Box
							sx={{
								pt: '20px',
								display: 'flex',
								flexDirection: 'row',
							}}
						>
							<Typography
								sx={{
									fontSize: '1rem',
									color: '#555',
								}}
							>
								{items?.totalCount ? `Total items: ` : ''}
							</Typography>
							&nbsp;
							<Typography
								sx={{
									fontSize: '1rem',
									fontWeight: 'bold',
									color: 'primary.main',
								}}
							>
								{items?.totalCount ? `${String(items?.totalCount ?? '')} ` : 'No data found'}
							</Typography>
						</Box>
					)}
				</Box>
			)}
		</Box>
	);
};
